module.exports = __webpack_public_path__ + "static/media/insta15.47fb2132.jpg";